<h2 mat-dialog-title>{{ 'common.log-in-required' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'common.log-in-required-message' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button type="button" (click)="onLogout()" [disabled]="isLoading">OK</button>
</mat-dialog-actions>
